export default "__VITE_ASSET__DD4tIChD__"